const colors = [
  '#111E6C',
  '#003152',
  '#0E4D92',
  '#0080FF',
  '#008ECC',
  '#4C516D',
  '#73C2FB',
  '#4F97A3',
  '#4682B4',
  '#89CFF0',
  '#7EF9FF',
  '#B0DFE5',
  '#1D2951',
  '#000080',
  '#1034A6',
  '#0F52BA',
  '#6593F5',
  '#008081',
  '#7285A5'
];

export default colors;



// WEBPACK FOOTER //
// ./source/client/components/common/arrayColors.js